export enum UserReducerType {
  CLEAN_ALL_USERS = 'clean-all-users',
  SET_ALL_USERS = 'set-all-users',
  SET_CREATE_USER = 'set-create-user',

  SET_ALL_STUDENTS = 'set-all-students',
  SET_FILTERED_STUDENTS = 'set-filtered-students',
  SET_CURRENT_STUDENT = 'set-current-student',
  SET_UPDATE_STUDENT = 'set-update-student',

  SET_ALL_TEACHERS = 'set-all-teachers',
  SET_FILTERED_TEACHERS = 'set-filtered-teachers',

  SET_ALL_ADMINISTRATORS = 'set-all-administrators',
  SET_FILTERED_ADMINISTRATORS = 'set-filtered-administrators',

  SET_ALL_VEHICLE_LICENSES = 'set-all-vehicle-licenses',
  SET_LICENSES = 'set-licenses',
  SET_SELECTED_LICENSE = 'set-selected-license',

  SET_CREATE_DEBT = 'set-create-debt',
  SET_CREATE_PAYMENT = 'set-create-payment',

  SET_EDIT_MODE = 'set-edit-mode',
  SET_IS_VALID = 'set-is-valid',
}
